<template>
  <div class="main"></div>
</template>

<script>
export default {
  name: "PageNotFound",
  data() {
    return {};
  },
  created() {
    console.log("aaaa");
    window.location.href = "/";
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue